import React, { memo, MouseEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../chatBot.module.scss';
import { Button } from './Button';
import { AddMessage } from '../../redux/reducers/chatBotReducer';
import { fetchSendMessages } from '../servises';
import { PAMMState } from '../../redux/reducers/rootReducer';

export const SuggestedQuestions = memo(() => {
  const dispatch = useDispatch();
  const { SuggestedQuestions: suggestedQuestions, FetchStatus } = useSelector((state: PAMMState) => state.chatBotReducer);

  const onSendSuggestedQuestions = useCallback((e: MouseEvent<HTMLElement>) => {
    const value: string = (e.target as HTMLElement).innerText;

    dispatch(AddMessage({ text: value, role: 'user' }));
    dispatch(fetchSendMessages({ value: escape(value) }));
  }, []);

  return (
    <div className={styles['suggestedQuestions']}>
      {suggestedQuestions?.length > 0 &&
        suggestedQuestions.map((item: string) => (
          <React.Fragment key={item}>
            {FetchStatus.loading ? (
              <div className={styles['skeleton']} />
            ) : (
              <Button
                text={item}
                cb={onSendSuggestedQuestions}
                cls={styles['msgButtonBot']}
                disabled={FetchStatus.loading || FetchStatus.status !== 200}
              />
            )}
          </React.Fragment>
        ))}
    </div>
  );
});
